import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import EscritorioSection from "./components/EscritorioSection";
import AreasAtuacao from "./components/AreasAtuacao";
import Diferenciais from "./components/Diferenciais";
import ComoAtuamos from "./components/ComoAtuamos";
import CTASection from "./components/CTASection";
import ContatoSection from "./components/ContatoSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="font-sans antialiased">
      <Navbar />
      <HeroSection />
      <EscritorioSection />
      <AreasAtuacao />
      <Diferenciais />
      <ComoAtuamos />
      <CTASection />
      <ContatoSection />
      <Footer />
    </main>
  );
}
